module.exports = __webpack_public_path__ + "img/main-flower2.494f4cb4.svg";